import React from "react";

import { inject, observer } from "mobx-react";

import { PermissionsController } from "../../PermissionsController";
import { PanelControls } from "./PanelControls";
import { PermissionCard } from "./PermissionCard";

@inject("permissionsController", "store")
@observer
export class PermissionsList extends React.Component<{
  permissionsController?: PermissionsController;
}> {
  public render() {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <PanelControls>
          <div style={{ overflow: "visible", paddingBottom: 0, flex: 1 }}>
            <PermissionCard />
          </div>
        </PanelControls>
      </div>
    );
  }
}
